import React from "react"
import PropTypes from "prop-types"

const Twitter = ({ fillColor, width, height }) => (

  /*
  * Old twitter Icon
  * <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6642 3.33608C12.1929 2.96842 12.6376 2.50951 13 1.9811V1.98057C12.5163 2.18801 12.0017 2.32594 11.4644 2.39279C12.0169 2.0697 12.4388 1.56198 12.6371 0.950278C12.122 1.25109 11.5532 1.4633 10.9471 1.58214C10.458 1.07177 9.76083 0.756104 9.00033 0.756104C7.52483 0.756104 6.33695 1.92911 6.33695 3.36685C6.33695 3.57375 6.35483 3.7727 6.3987 3.9621C4.18329 3.856 2.22246 2.81616 0.905124 1.23146C0.675458 1.62246 0.540041 2.0697 0.540041 2.55089C0.540041 3.45491 1.01508 4.25602 1.72412 4.72023C1.29567 4.71227 0.875874 4.59025 0.52 4.39873V4.42738C0.52 5.69588 1.44354 6.74951 2.65525 6.9925C2.43804 7.05085 2.20187 7.07844 1.9565 7.07844C1.78587 7.07844 1.61362 7.06889 1.45221 7.03388C1.79725 8.06735 2.77766 8.8276 3.94225 8.85254C3.0355 9.547 1.88392 9.96559 0.637541 9.96559C0.41925 9.96559 0.209625 9.95604 0 9.93005C1.18083 10.6754 2.57942 11.1015 4.0885 11.1015C8.79179 11.1015 11.8571 7.25829 11.6642 3.33608Z"
      fill={fillColor}
    />
  </svg> */
  <svg xmlns="http://www.w3.org/2000/svg" height={width} width={height} viewBox="0 0 512 512">
    <path
      fill={fillColor}
      d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
  </svg>
)

Twitter.propsTypes = {
  fillColor: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

Twitter.defaultProps = {
  fillColor: "currentColor",
  width: "18px",
  height: "18px",
}

export { Twitter }
